import React from "react";
import Helmet from "react-helmet";
import favicon from "../../assets/favicon/favicon.ico";
import appleIcon from "../../assets/favicon/apple-touch-icon.png";
import favicon32 from "../../assets/favicon/favicon-32x32.png";
import favicon16 from "../../assets/favicon/favicon-16x16.png";
import logo from "../../assets/images/landing/procedural_logoname_#D3D3D3_200x100.png";
import metaImage from "../../assets/images/landing/procedural_logoname_#D3D3D3_200x100.png";

export const SEO = (props) => {
let {metaTitle, metaAuthor, metaDescription, canonicalUrl, metaDate} = props;

  return (
    <>
      <Helmet>
        {metaTitle ? <title>{metaTitle}</title> : null}
        {metaTitle ? <meta name="title" content={metaTitle} /> : null}
        {metaAuthor ? <meta name="author" content={metaAuthor} /> : null}
        {metaDescription ? <meta name="description" content={metaDescription} /> : null}
        {metaTitle ? <meta property="og:title" content={metaTitle} /> : null}
        {metaDescription ? <meta property="og:description" content={metaDescription} /> : null}
        {metaImage ? <meta name="image" property="og:image" content={`https://compute.procedural.build${metaImage}`} /> : null}
        {metaImage ? <meta name="twitter:image" content={`https://compute.procedural.build${metaImage}`} /> : null}
        {metaTitle ? <meta property="twitter:title" content={metaTitle} /> : null}
        {metaDescription ? <meta property="twitter:description" content={metaDescription} /> : null}
        <meta name="twitter:site" content="@ApsProcedural" />
        <meta name="twitter:creator" content="@ApsProcedural" />
        <link rel="canonical" href={canonicalUrl} />
        <link rel="icon" type="image/png" href={favicon} />
        <link rel="apple-touch-icon" sizes="180x180" href={appleIcon} />
        <link rel="icon" type="image/png" sizes="32x32" href={favicon32} />
        <link rel="icon" type="image/png" sizes="16x16" href={favicon16} />
        <script type="application/ld+json">
          {`{
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "https://compute.procedural.build${canonicalUrl}"
            },
            "image": [
              "https://compute.procedural.build${metaImage}"
            ],
            "headline": "${metaTitle}",
            "datePublished": "${metaDate}T08:00:00+01:00",
            "dateModified": "${metaDate}T08:00:00+01:00",
            "author": {
              "@type": "Person",
              "name": "Christian Kongsgaard"
            },
            "publisher": {
              "@type": "Organization",
              "name": "Procedural",
              "logo": {
                "@type": "ImageObject",
                "url": "https://compute.procedural.build${logo}"
              }
            }
          }`}
        </script>
      </Helmet>
    </>
  );
};
